import { HiAcademicCap } from "react-icons/hi2";
import { MdLibraryBooks } from "react-icons/md";
import { DiAtlassian } from "react-icons/di";



const data=[
    {id:1, icon:<HiAcademicCap/>, title: "Experience", desc: "1+ Year Experience"},
    {id:2, icon:<MdLibraryBooks/>, title: "Projects", desc: "20+ Completed"},
    {id:3, icon:<DiAtlassian/>, title: "Clients", desc: "10+ Happy clients"}
    
]
export default data